import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CreateEntityBudgetSubItemBody,
  EntityBudgetSubItemApi,
  FilterEntityBudgetSubItemOption,
  UpdateEntityBudgetSubItemBody,
} from 'api';

import { RootState } from '../app';

export const findBudgetSubItemByEntity = createAsyncThunk(
  'entityBudgetSubItem/findBudgetSubItemByEntity',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityBudgetSubItemApi.findWithEntity(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityBudgetSubItem = createAsyncThunk(
  'entityBudgetSubItem/findOneEntityBudgetSubItem',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await EntityBudgetSubItemApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntityBudgetSubItem = createAsyncThunk(
  'entityBudgetSubItem/filterEntityBudgetSubItem',
  async (option: FilterEntityBudgetSubItemOption, { rejectWithValue }) => {
    try {
      const response = await EntityBudgetSubItemApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityBudgetSubItem = createAsyncThunk(
  'entityBudgetSubItem/createEntityBudgetSubItem',
  async (body: CreateEntityBudgetSubItemBody, { rejectWithValue }) => {
    try {
      const response = await EntityBudgetSubItemApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityBudgetSubItem = createAsyncThunk(
  'entityBudgetSubItem/updateEntityBudgetSubItem',
  async (
    params: {
      id: string;
      body: UpdateEntityBudgetSubItemBody;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityBudgetSubItemApi.update(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityBudgetSubItem = createAsyncThunk(
  'entityBudgetSubItem/removeEntityBudgetSubItem',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityBudgetSubItemApi.remove(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  listAll: Array<any>;
  isInitData: boolean;
  entityDocumentSubCategoriesHash: any;
}

const initialState: IState = {
  list: [],
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả chứng từ',
    },
  ],
  isInitData: false,
  entityDocumentSubCategoriesHash: {},
};

const entityBudgetSubItemSlice = createSlice({
  name: 'entityBudgetSubItem',
  initialState,
  reducers: {},
});

const { reducer: entityBudgetSubItemReducer } = entityBudgetSubItemSlice;

export default entityBudgetSubItemReducer;

export const selectEntityBudgetSubItem = (state: RootState): IState =>
  state.entityBudgetSubItem as IState;
